import { createLink, LinkComponent } from '@tanstack/react-router'
import { VariantProps } from 'class-variance-authority'
import { AnchorHTMLAttributes, forwardRef } from 'react'

import { ButtonContext, buttonVariants } from '../button/Button'
import { cn } from '@/ui/utils/style'

interface InternalLinkButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: VariantProps<typeof buttonVariants>['variant']
  size?: VariantProps<typeof buttonVariants>['size']
  spacing?: VariantProps<typeof buttonVariants>['spacing']
  'data-testid'?: string
}

const InternalLinkButtonBaseComponent = createLink(
  forwardRef<HTMLAnchorElement, InternalLinkButtonProps>(
    ({ variant, size, spacing, className, children, ...props }, ref) => {
      return (
        <a ref={ref} className={cn(buttonVariants({ variant, size, spacing }), className)} {...props}>
          <ButtonContext.Provider value={{ size }}>{children}</ButtonContext.Provider>
        </a>
      )
    },
  ),
)

// eslint-disable-next-line func-style
export const InternalLinkButton: LinkComponent<typeof InternalLinkButtonBaseComponent> = (props) => {
  return <InternalLinkButtonBaseComponent {...props} />
}

export interface ExternalLinkButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string
  variant?: VariantProps<typeof buttonVariants>['variant']
  size?: VariantProps<typeof buttonVariants>['size']
  spacing?: VariantProps<typeof buttonVariants>['spacing']
  'data-testid'?: string
}

export const ExternalLinkButton = forwardRef<HTMLAnchorElement, ExternalLinkButtonProps>(
  ({ to, variant, size, spacing, className, children, ...props }, ref) => {
    return (
      <a
        {...props}
        href={to}
        ref={ref}
        className={cn(buttonVariants({ variant, size, spacing }), className)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ButtonContext.Provider value={{ size }}>{children}</ButtonContext.Provider>
      </a>
    )
  },
)
